<template>
  <b-modal id="mass-change-status-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('idp.change_learning_statuses') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-p adp-p__grey adp-modal-row" v-html="$t('idp.change_learning_status_help')"></div>
      <div class="adp-p adp-p__grey adp-modal-row" v-html="$t('idp.select_learning_activity')"></div>
      <v-select :options="learningActivities" v-model="learningActivityId">
        <template #selected-option="option">
          <p style="height: 26px; overflow-y: hidden; line-height: 26px; font-size: 14px; color: #292929;">
            {{ option.label.length > 72 ? option.label.substr(0, 72) + '...' : option.label }}
          </p>
        </template>
        <template #option="option">
          <span class="adp-p" style="width: 100%; white-space: initial;">{{ option.label }}</span>
        </template>
        <template #no-options="{ search, searching }">
          <template v-if="searching">
            {{ $t('catalog.no_result_name') }} <em>{{ search }}</em>.
          </template>
          <span class="adp-p adp-p__grey" v-else>{{ $t('catalog.start_typing_for_search') }}</span>
        </template>
      </v-select>
      <div class="adp-p adp-p__grey adp-modal-row" v-if="learningActivityId"
           v-html="$t('idp.display_only_with_assigned_learning')">
      </div>
      <div class="adp-grid-table-clm4" v-if="learningActivityId">
        <div></div>
        <div class="d-flex justify-content-center">
          {{ $t('idp.done') }}
        </div>
        <div class="d-flex justify-content-center">
          {{ $t('idp.canceled') }}
        </div>
        <div class="d-flex justify-content-center">
          {{ $t('idp.rejected') }}
        </div>
        <div>Выбрать всех</div>
        <div class="d-flex justify-content-center" style="padding-left: 4px;">
          <b-form-checkbox v-model="all" @change="toggleAll($event)" value="done"
                           :indeterminate.sync="indeterminateDone">&nbsp;</b-form-checkbox>
        </div>
        <div class="d-flex justify-content-center" style="padding-left: 4px;">
          <b-form-checkbox v-model="all" @change="toggleAll($event)" value="canceled"
                           :indeterminate.sync="indeterminateCanceled">&nbsp;</b-form-checkbox>
        </div>
        <div class="d-flex justify-content-center" style="padding-left: 4px;">
          <b-form-checkbox v-model="all" @change="toggleAll($event)" value="rejected"
                           :indeterminate.sync="indeterminateRejected">&nbsp;</b-form-checkbox>
        </div>
        <template v-for="(employee, i) in employeesVisible" style="height: 48px;">
          <div class="adp-modal-employee-link" @click="openInNewTab(employee.pernumber)">{{ employee.fullname }}</div>
          <div class="d-flex justify-content-center" style="padding-top: 8px;">
            <b-form-checkbox v-model="employeesVisible[i].idpStatus" :name="String(employeesVisible[i].pernumber)" value="done"></b-form-checkbox>
          </div>
          <div class="d-flex justify-content-center" style="padding-top: 8px;">
            <b-form-checkbox v-model="employeesVisible[i].idpStatus" :name="String(employeesVisible[i].pernumber)" value="canceled"></b-form-checkbox>
          </div>
          <div class="d-flex justify-content-center" style="padding-top: 8px;">
            <b-form-checkbox v-model="employeesVisible[i].idpStatus" :name="String(employeesVisible[i].pernumber)" value="rejected"></b-form-checkbox>
          </div>
        </template>
      </div>
    </template>

    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="save()" :disabled="isButtonDisabled">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import CompetenceSkillsBlock from "./../CompetenceSkillsBlock";
import api from "../../api";
import MyDatePicker from "../MyDatePicker";
import Vue from "vue";

export default {
  name: "MassChangeStatusModal",
  components: {
    'competence-skills-block': CompetenceSkillsBlock,
    'my-date-picker': MyDatePicker,
  },
  props: {
    employeesProps: {
      type: Object,
    },
  },
  data: function () {
    return {
      learningActivityId: null,
      learningActivities: [],

      indeterminateDone: false,
      indeterminateCanceled: false,
      indeterminateRejected: false,

      all: null,
      employees: null,
      employeesVisible: null,
      isLoading: null,

      currentYear: new Date().getFullYear(),
      isButtonDisabled: true,
    }
  },
  watch:{
    employeesVisible: {
      handler: function(newValue) {
        if (newValue === null) {
          return;
        }
        let cntDone = 0;
        let cntRejected = 0;
        let cntCanceled = 0;
        for (const pernumber in newValue) {
          newValue[pernumber].hasOwnProperty('idpStatus') && newValue[pernumber].idpStatus === 'done' ? cntDone++: cntDone+=0;
          newValue[pernumber].hasOwnProperty('idpStatus') && newValue[pernumber].idpStatus === 'rejected' ? cntRejected++: cntRejected+=0;
          newValue[pernumber].hasOwnProperty('idpStatus') && newValue[pernumber].idpStatus === 'canceled' ? cntCanceled++: cntCanceled+=0;
        }
        if (cntDone === 0) {
          this.all = null;
          this.indeterminateDone = false;
        } else if (cntDone < newValue.length) {
          this.indeterminateDone = true;
        }
        if (cntCanceled === 0) {
          this.all = null;
          this.indeterminateCanceled = false;
        } else if (cntCanceled < newValue.length) {
          this.indeterminateCanceled = true;
        }
        if (cntRejected === 0) {
          this.all = null;
          this.indeterminateRejected = false;
        } else if (cntRejected < newValue.length) {
          this.indeterminateRejected = true;
        }

        if (cntDone === newValue.length) {
          this.all = 'done';
          this.indeterminateDone = false;
          this.indeterminateCanceled = false;
          this.indeterminateRejected = false;
        } else if (cntCanceled === newValue.length) {
          this.all = 'canceled';
          this.indeterminateDone = false;
          this.indeterminateCanceled = false;
          this.indeterminateRejected = false;
        } else if (cntRejected === newValue.length) {
          this.all = 'rejected';
          this.indeterminateDone = false;
          this.indeterminateCanceled = false;
          this.indeterminateRejected = false;
        }

        if (this.employeesVisible.length) {
          this.employeesVisible.map(e => {
            if (e.idpStatus) this.isButtonDisabled = false;
          });
          if (!this.employeesVisible.filter(e => e.idpStatus).length) {
            this.isButtonDisabled = true;
          }
        }

      },
      deep: true
    },
    learningActivityId(newValue) {
      if (newValue !== null) {
        let newEmployeesVisible = this.employees.filter(el => el.learning_activity_id === newValue.code);
        Vue.set(this, 'employeesVisible', newEmployeesVisible);
      } else {
        Vue.set(this, 'employeesVisible', null);
      }
    }
  },
  methods: {
    onShow() {
      (async () => {
        this.isLoading = true;
        let res = await api.getLearningActivities(Object.keys(this.employeesProps), this.currentYear);

        this.employees = res.data.map(la => {
          let activity = Object.values(this.employeesProps).find(emp => emp.pernumber === la.pernumber)
          return {...la, ...activity}
        });

        this.learningActivities = res.data
          .map((e) => {
            return {code: e.learning_activity_id, label: e.name, data: e}
          }).filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i);

        this.isLoading = false;
      })();
    },
    toggleAll(e) {
      for (const pernumber in this.employeesVisible) {
        Vue.set(this.employeesVisible[pernumber], 'idpStatus', e)
      }
      this.indeterminateDone = false;
      this.indeterminateCanceled = false;
      this.indeterminateRejected = false;
    },
    async save() {
      try {
        let data = this.employeesVisible.filter(el => {
          return !!el.idpStatus;
        }).map(el => {
          return {
            idp_activity_id: el.idp_activity_id,
            status: el.idpStatus,
          }
        });
        await api.massIDPActivityAgreement(this.$role, data);
        this.$emit('mass-change-status');
      } catch (e) {
        console.error(e.response.data);
        this.$toasts.error(JSON.stringify(e.response.data, null, 2), {
          duration: 700000,
        });
      }
    },
    openInNewTab(pernumber) {
      let routeData = this.$router.resolve({ name: `${this.$role}-employee`, params: { pernumber: pernumber }});
      window.open(routeData.href, '_blank');
    },
  },
}
</script>
